import { render, staticRenderFns } from "./RealtimeRisk.vue?vue&type=template&id=43865467&"
import script from "./RealtimeRisk.vue?vue&type=script&lang=js&"
export * from "./RealtimeRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports